module.exports = __webpack_public_path__ + "img/img_charge_phone_img2.68bc9edb.png";